module.exports = __webpack_public_path__ + "img/backpack-usd-table-icon.786f2483.svg";